import { Link } from "react-router-dom";

export default function LegalFooter({ className = "" }) {
  return (
    <footer className={`text-center text-xs text-zinc-500 ${className}`} data-testid="legal-footer">
      <div className="flex items-center justify-center gap-3 flex-wrap">
        <Link to="/mentions-legales" data-testid="footer-mentions-legales" className="hover:text-zinc-300 hover:underline">Mentions légales</Link>
        <span className="text-zinc-700">·</span>
        <Link to="/confidentialite" data-testid="footer-confidentialite" className="hover:text-zinc-300 hover:underline">Politique de confidentialité</Link>
      </div>
      <p className="mt-2 text-zinc-600">© {new Date().getFullYear()} PACAZUR PROTECT — Tous droits réservés</p>
    </footer>
  );
}
